import {
  numberWithSpaces,
} from 'utils/helpers'

const formatMoney = ({ value, fractionDigits, currency = 'USD' }: ApplicationCalculationMoneyArgs) => {
  if (value == null || value === '') {
    return '—'
  }
  const numeric = Number(value)
  if (Number.isNaN(numeric)) {
    return '—'
  }
  if (fractionDigits != null) {
    const formatted = new Intl.NumberFormat('ru-RU', {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(numeric)
    return `${formatted} ${currency}`
  }
  return `${numberWithSpaces(numeric)} ${currency}`
}

export const formatUsd = ({ value, fractionDigits }: ApplicationCalculationCurrencyMoneyArgs) => (
  formatMoney({ value, fractionDigits, currency: 'USD' })
)

export const formatRub = ({ value, fractionDigits = 2 }: ApplicationCalculationCurrencyMoneyArgs) => (
  formatMoney({ value, fractionDigits, currency: 'RUB' })
)
